import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from '../../store/actions';
import AssetUpload from 'main/content/asset/AssetUpload';
import CanvasEditor from './CanvasEditor';
import { server_connection } from 'config';

const styles = theme => ({
});

class HotSpotAnswer extends Component {
    render() {
        const { question, view_type } = this.props;
        
        return (
            <React.Fragment>
                <CanvasEditor 
                    question={question}
                    view_type={view_type}
                />
            </React.Fragment>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateQuestionImage: Actions.updateQuestionImage,
    }, dispatch);
}

function mapStateToProps({ auth, quizApp, questionApp, paramHistory }) {
    return {
        auth
    }
}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(HotSpotAnswer)));



// WEBPACK FOOTER //
// src/main/content/quiz/quizBuilder/questionType/HotSpotAnswer.js